module.exports = __webpack_public_path__ + "static/media/kindleNotes.6f0bc1cc.pegjs";


//////////////////
// WEBPACK FOOTER
// ./src/grammar/kindleNotes.pegjs
// module id = 68
// module chunks = 0